import ArrowRight from '@icons/ArrowRight.jsx'

const SearchStatic = ({ staticData, handleSuggestionClick, noresults }) => {
	const sections = staticData.static.sections;

	return (
		<div className={`search-static-outer lg:rounded-b-lg bg-white h-full overflow-y-auto ${noresults ? 'py-4' : 'p-8'}`}>
			<div className='search-static-inner flex flex-col xl:flex-row gap-2 md:gap-8 w-full wrap-md mx-auto font-akkurat'>
            <div
					className={`search-static-stack w-full lg:w-1/4 ${
						noresults ? 'hidden' : ''
					}`}
				>
					{sections.map((s, index) => {
						if (s.title === 'Top Searches') {
							return (
								<div
									className={`search-static-section static-section-${s.slug}`}
									key={index}
								>
									<div className='search-static-title text-web-s3-section-content mb-2'>
										{s.title}
									</div>
									<div className='search-static-content mt-1 mb-4'>
										<ul className='searches-list nostyle flex flex-wrap gap-2 px-2 md:grid md:grid-cols-2 lg:flex lg:flex-col lg:flex-nowrap'>
											{s.searches.map((search, i) => {
												return (
													<li
														className='search-item text-text-primary hover:underline font-normalcursor-pointer'
														key={i}
														onClick={() =>
															handleSuggestionClick(
																search.title
															)
														}
													>
														{search.title}

													</li>
												);
											})}
										</ul>
									</div>
								</div>
							);
						}

					})}
				</div>
				{sections.map((s, index) => {
					if (s.title === 'Top Categories') {
						return (
							<div
								className={`search-static-section font-akkurat w-full static-section-${
									s.slug
								} ${noresults ? 'w-full' : 'md:flex-1'}`}
								key={index}
							>
								<div className='search-static-title text-web-s3-section-content mb-2'>
									{s.title}
								</div>
								<div className='search-static-content mt-1 mb-4'>
									<ul className='categories-list nostyle grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-8'>
										{s.categories.map((c, i) => {
											return (
												<li
													className='category-item'
													key={i}
												>
													<div className='category-item-image hover:opacity-80'>
														<a href={c.url}>
															<div
																className="flex items-center justify-center"

															>
																<img
																	src={c.imageSrc}
																	alt={c.imageAlt}
																	loading='lazy'
																	className="w-full h-full object-contain"
																/>
															</div>
														</a>
													</div>
													<div className='category-item-title mt-2'>
														<a
															className='flex items-center gap-1 text-mobile-b1-body-1 lg:text-web-b1-body-1 lg:font-bold'
															href={c.url}
														>
															{c.title}
                                                            <ArrowRight width="w-[16px]" />
														</a>
													</div>
												</li>
											);
										})}
									</ul>
								</div>
							</div>
						);
					}
					return null;
				})}

			</div>
		</div>
	);
};

export default SearchStatic;
